// Shared steps for town pages. Posting is a request for prices, not a booking.
export const AREA_STEPS = [
  {
    n: '01',
    title: 'Post the job free',
    body: 'Describe the waste, roughly how much there is, the area, and anything awkward about stairs, lanes or parking. You need a free customer account. Posting does not cost anything.',
  },
  {
    n: '02',
    title: 'Carriers send prices',
    body: 'Registered waste carriers can send a price. A price is an offer, not a booking. Carriers choose which jobs to price, so you may see one price, several, or none.',
  },
  {
    n: '03',
    title: 'You choose',
    body: 'If a price suits you, accept it. You do not pay to accept. If none of them suit you, leave the job. Nothing is booked until you accept.',
  },
  {
    n: '04',
    title: 'Pay when it is done',
    body: 'On a priced job you pay the price you accepted, by card, only after the job is marked complete. The WasteGame does not add a customer fee on top.',
  },
];
